import * as React from 'react';
import { Button, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { serviceLocator } from '../../services';
import { MainPadding } from '../../components/MainPadding';
import { AppSection } from '../../components/AppSection';
import { withSnackbar, WithSnackbarProps } from '../../components/withSnackbar';
import axios from 'axios';

const authenticationService = serviceLocator.getAuthenticationService();

const ImgPreview = styled('img')({
  width: '100%',
  height: '100%',
  maxWidth: '300px',
  maxHeight: '300px',
});

const ButtonsWrapper = styled('div')({
  display: 'flex',
});

export interface AgencyGeneralState {
  selectedFile: any;
  file: any;
}

interface AgencyGeneralProps extends WithSnackbarProps {
  selectedAgency: string;
}

const noImage = "https://trusteid.mioa.gov.mk/wp-content/plugins/uix-page-builder/uixpb_templates/images/UixPageBuilderTmpl/no-logo.png";

export class AgencyGeneralInner extends React.Component<AgencyGeneralProps, AgencyGeneralState>{

  constructor(props: AgencyGeneralProps) {
    super(props);
    this.state = {
      selectedFile: noImage,
      file: null
    };
  }

  componentDidMount() {
    this.getLogo()
  }

  getLogo = async () => {
    const authUserData = authenticationService.getAuthenticatedUserData();
    const response = await axios.get(`/api/agencies/${this.props.selectedAgency}/logo/`);
    console.log('response', response)
    if (response.data?.success == false) {
      this.setState({
        selectedFile: noImage
      });
    } else {
      this.setState({
        selectedFile: "data:image\/png;base64, " + response.data
      });
    }
  }

  handleUploadClick = (event: any) => {
    console.log();
    var file = event.target.files[0];
    const reader = new FileReader();
    var url = reader.readAsDataURL(file);
    const that = this;
    reader.onloadend = function (e: any) {
      that.setState({
        selectedFile: [reader.result]
      });
    }.bind(this);
    console.log(url); // Would see a path?

    this.setState({
      selectedFile: event.target.files[0],
      file
    });
  };

  saveLogo = async () => {
    const authUserData = authenticationService.getAuthenticatedUserData();
    var file = this.state.file;
    const formData = new FormData();
    formData.append("logo", file);
    const response = await axios.post(`/api/agencies/${this.props.selectedAgency}/logo/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    console.log('response', response)
  };

  public render() {
    const authUserData = authenticationService.getAuthenticatedUserData();

    return (
      <MainPadding>
        <AppSection section="themePanel" />
        <Typography variant="h6">Agency General Settings</Typography><br />
        <Paper style={{ padding: "25px", paddingTop: "10px" }}>
          <p style={{ fontSize: "16px", fontWeight: "500" }}>
            Agency Logo
          </p>
          <div style={{ marginBottom: "30px" }}>

            {/* <Avatar alt={this.props.selectedAgency} src="/static/images/avatar/1.jpg" /> */}
            <ImgPreview src={this.state.selectedFile} alt={this.props.selectedAgency} />

            <ButtonsWrapper>
              <div>
                <input
                  accept="image/*"
                  style={{ display: "none" }}
                  id="contained-button-file"
                  type="file"
                  onChange={this.handleUploadClick}
                />
                <label htmlFor="contained-button-file">
                  <Button variant="contained" color="secondary" component="span">
                    Select File
                  </Button>
                </label>
              </div>

              <Button onClick={this.saveLogo} variant="contained" color="primary" style={{ marginLeft: "100px" }}>
                Save
              </Button>
            </ButtonsWrapper>
          </div>
        </Paper>
      </MainPadding>
    );
  }
}

export const AgencyGeneral = withSnackbar(AgencyGeneralInner);
